import React from 'react';
import { motion } from 'framer-motion';

export default function Showcase() {
  return (
    <section id="solutions" className="py-32 bg-white border-y border-gray-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex flex-col gap-32">
        
        {/* Block 1: Image Left, Text Right */}
        <div>
          <motion.h2 
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl sm:text-[40px] text-[#1F2937] tracking-tight mb-12 max-w-xl leading-[1.1]"
          >
            Co wyróżnia Rzut Nieruchomości?
          </motion.h2>
          
          <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24">
            <motion.div 
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="flex-1 w-full"
            >
              {/* Notion-style Mockup */}
              <div className="bg-white rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-200/60 overflow-hidden h-[400px] flex">
                <div className="w-48 bg-[#F9FAFB] border-r border-gray-100 p-4 hidden sm:block">
                  <div className="flex items-center gap-2 mb-6">
                    <div className="w-6 h-6 rounded bg-[#1F2937] text-white flex items-center justify-center text-[10px] font-bold">R</div>
                    <div className="text-[13px] font-medium text-gray-700">Rzut Nieruchomości</div>
                  </div>
                  <div className="space-y-2">
                    <div className="h-4 w-24 bg-gray-200/60 rounded"></div>
                    <div className="h-4 w-32 bg-gray-200/60 rounded"></div>
                    <div className="h-4 w-20 bg-gray-200/60 rounded"></div>
                  </div>
                </div>
                <div className="flex-1 p-8 flex flex-col relative">
                  <div className="flex justify-between items-center mb-8">
                    <div className="text-[13px] text-gray-400">Nowy rzutu</div>
                    <div className="flex gap-2">
                      <div className="w-4 h-4 rounded bg-gray-200"></div>
                      <div className="w-4 h-4 rounded bg-gray-200"></div>
                    </div>
                  </div>
                  <div className="text-2xl text-[#1F2937] mb-6 tracking-tight">Wybierz styl projektu</div>
                  
                  <div className="space-y-3 mb-8">
                    <div className="flex items-center gap-3 text-[13px] text-gray-500">
                      <div className="w-4 h-4 border border-gray-300 rounded-sm"></div>
                      Zacznij od pustego planu
                    </div>
                    <div className="flex items-center gap-3 text-[13px] text-gray-500">
                      <div className="w-4 h-4 border border-gray-300 rounded-sm"></div>
                      Wgraj szkic z kartki
                    </div>
                  </div>

                  <div className="mt-auto border border-gray-200 rounded-lg p-3 text-[13px] text-gray-400 flex items-center gap-2">
                    <span className="w-4 h-4 rounded-full bg-gray-100 flex items-center justify-center">+</span>
                    Narysuj pomieszczenie, ścianę lub dodaj mebel...
                  </div>
                </div>
              </div>
            </motion.div>
            
            <motion.div 
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="w-full lg:w-[35%] flex flex-col justify-center"
            >
              <p className="text-[15px] text-[#1F2937] leading-relaxed mb-10">
                Kreator napędza tysiące profesjonalnych ofert sprzedaży każdego dnia na największych portalach nieruchomości w Polsce.
              </p>
              
              <div>
                <p className="text-[12px] text-gray-500 mb-4">Funkcje:</p>
                <ul className="text-[13px] text-[#1F2937] font-medium space-y-3">
                  <li>Błyskawiczne generowanie rzutów</li>
                  <li>Środowisko projektowe w przeglądarce</li>
                  <li>Automatyczne linie wymiarowe</li>
                  <li>Zgodność z portalami (Otodom, Nieruchomości-online)</li>
                </ul>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Block 2: Text Left, Image Right (Centered Heading) */}
        <div>
          <motion.h2 
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl sm:text-[40px] text-[#1F2937] tracking-tight mb-12 text-center leading-[1.1]"
          >
            Skaluj działania od zera do setek ofert błyskawicznie
          </motion.h2>
          
          <div className="flex flex-col-reverse lg:flex-row items-center gap-16 lg:gap-24">
            <motion.div 
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="w-full lg:w-[35%] flex flex-col justify-center"
            >
              <p className="text-[15px] text-[#1F2937] leading-relaxed mb-10">
                Aplikacja obsługuje tysiące projektów tworzonych przez biura nieruchomości, zapewniając niezawodność, szybkość i brak ukrytych opłat.
              </p>
              
              <div>
                <p className="text-[12px] text-gray-500 mb-4">Właściwości:</p>
                <ul className="text-[13px] text-[#1F2937] font-medium space-y-3">
                  <li>Brak stałego abonamentu</li>
                  <li>Globalna dostępność w chmurze</li>
                  <li>Zarządzanie projektami w jednym miejscu</li>
                  <li>Nielimitowana liczba eksportów PNG</li>
                </ul>
              </div>
            </motion.div>
            
            <motion.div 
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="flex-1 w-full"
            >
              {/* Zapier-style Mockup */}
              <div className="bg-white rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-200/60 overflow-hidden h-[400px] flex flex-col">
                <div className="h-12 border-b border-gray-100 flex items-center px-6 justify-between bg-gray-50/50">
                  <div className="flex items-center gap-6">
                    <div className="text-[14px] font-semibold tracking-tight text-[#1F2937]">Kreator PRO</div>
                    <div className="hidden sm:flex gap-4 text-[12px] text-gray-500">
                      <span>Projekty</span>
                      <span>Szablony</span>
                      <span>Ustawienia</span>
                    </div>
                  </div>
                  <div className="w-6 h-6 rounded-full bg-gray-200"></div>
                </div>
                <div className="flex-1 flex flex-col items-center justify-center text-center p-8 bg-dots relative">
                  <div className="text-[10px] uppercase tracking-widest text-gray-400 mb-4 font-semibold">Zarządzanie Licencją</div>
                  <div className="text-3xl text-[#1F2937] tracking-tight mb-4">Twoje projekty. Twoje zasady.</div>
                  <div className="text-[13px] text-gray-500 max-w-sm mb-8">
                    Jedno miejsce do zarządzania wszystkimi rzutami. Buduj zaufanie klientów dzięki profesjonalnym materiałom.
                  </div>
                  <div className="flex gap-4 mb-16">
                    <div className="px-4 py-2 bg-gray-100 text-gray-600 rounded text-[13px] font-medium">Sprawdź demo</div>
                    <div className="px-4 py-2 bg-white border border-gray-200 text-gray-600 rounded text-[13px] font-medium">Utwórz rzut</div>
                  </div>
                  
                  <div className="flex gap-12 text-center absolute bottom-12">
                    <div>
                      <div className="text-xl text-[#1F2937] tracking-tight mb-1">10K+</div>
                      <div className="text-[10px] text-gray-400 uppercase tracking-widest">Stworzonych rzutów</div>
                    </div>
                    <div>
                      <div className="text-xl text-[#1F2937] tracking-tight mb-1">98%</div>
                      <div className="text-[10px] text-gray-400 uppercase tracking-widest">Zadowolenia</div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Block 3: Image Left, Text Right */}
        <div>
          <motion.h2 
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl sm:text-[40px] text-[#1F2937] tracking-tight mb-12 max-w-xl leading-[1.1]"
          >
            Standard, który obsługuje każdego klienta
          </motion.h2>
          
          <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24">
            <motion.div 
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="flex-1 w-full"
            >
              {/* Mintlify-style Mockup */}
              <div className="bg-white rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-200/60 overflow-hidden h-[400px] flex">
                <div className="w-48 bg-white border-r border-gray-100 p-4 hidden sm:block">
                  <div className="text-[12px] text-gray-400 mb-4 px-2">Personalizacja</div>
                  <div className="space-y-1">
                    <div className="text-[13px] text-[#1F2937] font-medium bg-gray-50 px-2 py-1.5 rounded">Logo i Znak wodny</div>
                    <div className="text-[13px] text-gray-500 px-2 py-1.5">Kolorystyka ścian</div>
                    <div className="text-[13px] text-gray-500 px-2 py-1.5">Eksport PDF / PNG</div>
                    <div className="text-[13px] text-gray-500 px-2 py-1.5">Opisy pomieszczeń</div>
                  </div>
                </div>
                <div className="flex-1 bg-[#FAFAFA] p-8 flex flex-col items-center justify-center relative overflow-hidden">
                  <div className="text-[18px] text-[#1F2937] tracking-tight mb-2">Twoja Marka na Rzucie</div>
                  <div className="text-[13px] text-gray-500 mb-8 max-w-xs text-center">
                    Wyróżnij się z tłumu i zabezpiecz swoje materiały przed nieautoryzowanym wykorzystaniem.
                  </div>
                  
                  <div className="grid grid-cols-2 gap-4 w-full max-w-sm">
                    <div className="bg-white border border-gray-200 rounded-lg p-4 flex flex-col items-center justify-center gap-3 aspect-square shadow-sm">
                      <div className="w-12 h-12 bg-gray-50 rounded-full border border-gray-100 flex items-center justify-center">
                        <div className="w-6 h-6 border-2 border-dashed border-gray-300 rounded-sm"></div>
                      </div>
                      <div className="text-[11px] text-gray-500">Wgraj Logo</div>
                    </div>
                    <div className="bg-white border border-gray-200 rounded-lg p-4 flex flex-col items-center justify-center gap-3 aspect-square shadow-sm">
                      <div className="flex gap-1.5">
                        <div className="w-4 h-4 rounded bg-[#1F2937]"></div>
                        <div className="w-4 h-4 rounded bg-gray-300"></div>
                        <div className="w-4 h-4 rounded bg-blue-500"></div>
                      </div>
                      <div className="text-[11px] text-gray-500 mt-2">Paleta Ścian</div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
            
            <motion.div 
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="w-full lg:w-[35%] flex flex-col justify-center"
            >
              <p className="text-[15px] text-[#1F2937] leading-relaxed mb-10">
                Personalizuj rzuty zgodnie ze swoim brandingiem. Buduj rozpoznawalność i profesjonalny wizerunek w sieci.
              </p>
              
              <div>
                <p className="text-[12px] text-gray-500 mb-4">Możliwości:</p>
                <ul className="text-[13px] text-[#1F2937] font-medium space-y-3">
                  <li>Dodawanie własnego logo</li>
                  <li>Półprzezroczyste znaki wodne</li>
                  <li>Dopasowanie kolorystyki projektu</li>
                  <li>Pełna własność wygenerowanych grafik</li>
                </ul>
              </div>
            </motion.div>
          </div>
        </div>

      </div>
    </section>
  );
}